import dxDataGrid from 'devextreme/ui/data_grid';

export function disableSorting() {
  dxDataGrid.defaultOptions({
    options: {
      sorting: {
        mode: 'none',
      },
    },
  });
}
